import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';

interface HelpTooltipProps {
  content: string;
  id?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({
  content,
  id,
  placement = 'top'
}) => {
  const tooltipId = id || `tooltip-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <>
      <span
        data-tooltip-id={tooltipId}
        data-tooltip-content={content}
        className="tw-inline-flex tw-items-center tw-justify-center tw-ml-2 tw-cursor-pointer"
      >
        <FontAwesomeIcon
          icon={faQuestionCircle}
          className="tw-text-gray-400 hover:tw-text-gray-600 tw-transition-colors tw-text-sm"
        />
      </span>
      <Tooltip
        id={tooltipId}
        place={placement}
        className="tw-max-w-xs tw-text-sm tw-bg-gray-800 tw-text-white tw-rounded-lg tw-shadow-lg tw-z-50"
        style={{
          backgroundColor: '#1f2937',
          color: '#ffffff',
          padding: '8px 12px',
          borderRadius: '8px',
          fontSize: '14px',
          lineHeight: '1.4',
          maxWidth: '320px',
          zIndex: 9999
        }}
      />
    </>
  );
};